import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roles: [],
  moduleAccess: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.roles = action.payload.roles;
      state.moduleAccess = action.payload.moduleAccess;
    },
    clearAuthData: (state) => {
      state.roles = [];
      state.moduleAccess = [];
    },
  },
});

// Action creators
export const { setAuthData, clearAuthData } = authSlice.actions;

// Selector (matches your loaderData pattern)
export const authData = (state) => state?.auth;

export default authSlice.reducer;